import styled from '@emotion/styled';
import { Popover } from '@mui/material';
import { bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { themeVars } from 'src/ui-components/theme/theme';

import whatsNew from '../../../assets/icons/menu/whats-new.svg';
import { MenuIcon, MenuItem, NavTitle } from '../helpers/styled';
import { useSidebarStore } from '../store/store';

export const WhatsNew = () => {
  const { collapsed } = useSidebarStore();

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'whatsNew',
  });

  return (
    <>
      <MenuItem $isCollapsed={collapsed} {...bindTrigger(popupState)}>
        <MenuIcon $src={whatsNew} />
        {!collapsed && <NavTitle> What&apos;s New </NavTitle>}
      </MenuItem>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Wrapper>
          <p>What&apos;s New</p>
          <ul>
            <li>
              You can now toggle between multiple sales metrics (Organic Sales, Paid Sales, Repeat
              Customers, and more) to better analyze performance over time.
            </li>
            <li>Compare overlapping metrics to identify trends and correlations.</li>
            <li>Opt to view a single metric for a more focused analysis.</li>
          </ul>
        </Wrapper>
      </Popover>
    </>
  );
};

const Wrapper = styled.div`
  padding: 16px;
  background: ${themeVars.colors.titan25};
`;
